import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Marchio } from 'my-lib-sanfelici';
import { MarchiService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-marchi-edit',
  templateUrl: './marchi-edit.component.html',
  styleUrls: ['./marchi-edit.component.css']
})
export class MarchiEditComponent implements OnInit {
marchio: Observable<Marchio>;
id: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private marchiservice: MarchiService) { }
save(m: Marchio) {

  this.marchiservice.update( m).then(() => {
    this.router.navigate(['marchi']);
  });
  console.log(m);
}
  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.marchio = this.marchiservice.get(this.id);

  }

}
